import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { OrderType } from 'src/app/components/company/models/new/order';
import { OrderTypeMapper } from 'src/app/components/company/services/order-type-mapper';
import { IFilterListService } from './ifilter-list.service';
import { OrderQueries } from 'src/app/shared/types/get-query';

@Injectable({
	providedIn: 'root'
})

export class OrderTypeFilterService extends IFilterListService<OrderType> {
	private readonly orderTypeMapper = inject(OrderTypeMapper);

	search(searchText: string): void {
		this.graphQlService
			.getData<any>(OrderQueries.GET_ORDER_TYPES, {})
			.pipe(map((res) => res.data.orderTypes.nodes.map((node: any) => this.orderTypeMapper.toOrderType(node))))
			.subscribe({
				next: (items: OrderType[]) => {
					const normalizedSearch = searchText?.trim().toLowerCase();
					const filteredItems = normalizedSearch ? items.filter((item) => item.name?.toLowerCase().includes(normalizedSearch)) : items;
					this.datasource.next(
						filteredItems.map((item) => ({
							...item,
							displayId: item.id,
							displayName: item.name,
							selected: false,
							disabled: false
						}))
					);
				}
			});
	}

	searchById(_id: string[] | string) {
		const ids = Array.isArray(_id) ? _id.map((id) => Number(id)) : [Number(_id)];

		return this.graphQlService
			.getData<any>(OrderQueries.GET_ORDER_TYPES, {})
			.pipe(map((res) => res.data.orderTypes.nodes.map((node: any) => this.orderTypeMapper.toOrderType(node))))
			.pipe(map((items: OrderType[]) => items.filter((item) => ids.includes(Number(item.id)))));
	}
}